<template>
    <PopupRouterView :showLeftIcon="true" label="Delivery Quality Inspection Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="deliveryqualityinspection"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="deliveryQualityInspectionInput">


        <b-card header="Delivery Quality Inspection" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Delivery Quality Inspection Number" :model="model.deliveryQualityInspectionNo" />
						<app-input-combobox-autocomplete :options="deliveryInstructions" optionsLabel="diNumber" optionsKey="id" label-cols-lg="12" label="Delivery Instruction" id="fieldset-delivery-instruction" size="sm" :model.sync="model.deliveryInstructionId"   :selected="model.deliveryInstruction != null ? model.deliveryInstruction.diNumber : ''" @input="getDeliveryInstructions" @change="updateData" :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedDeliveryInstruction" />
						<app-input-combobox-autocomplete :options="pickingStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Delivery Quality Inspection Status" id="fieldset-delivery-quality-inspection-status" size="sm" :model.sync="model.deliveryQualityInspectionStatusId"   :selected="model.deliveryQualityInspectionStatus != null ? model.deliveryQualityInspectionStatus.name : ''" @input="getPickingStatuss" @change="updateData" :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedDeliveryQualityInspectionStatus" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

		<app-table-input 
			title = "Delivery Quality Inspection Detail"
			:bordered="true" :items="deliveryQualityInspectionDetails" 
			:fields="fieldsDeliveryQualityInspectionDetail" 
			:busy="isDataLoading" 
			:sort-by.sync="sortByDeliveryQualityInspectionDetail" 
			:sort-desc.sync="sortDescDeliveryQualityInspectionDetail" small responsive	
			@editButtonMethod="editRowDataDeliveryQualityInspectionDetail"	
			@deleteButtonMethod="deleteRowDataDeliveryQualityInspectionDetail"	
			@showPopupAddMethod="addDataDeliveryQualityInspectionDetail()"	
			@showPopupUploadMethod="showPopupUploadDeliveryQualityInspectionDetail()"
			@downloadMethod="downloadDeliveryQualityInspectionDetail()"
			@addFromClipboardMethod="addFromClipboardDeliveryQualityInspectionDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardDeliveryQualityInspectionDetail()"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="true"	
			:showDownloadButton="true"	
			:isDownloadBusy="isDownloadDeliveryQualityInspectionDetail"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowDeliveryQualityInspectionDetailFilter = !isShowDeliveryQualityInspectionDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowDeliveryQualityInspectionDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Delivery Instruction Detail">
					<v-select id="input-delivery-quality-inspection-detail-delivery-instruction-detail-table" append-to-body label="part" :options="deliveryInstructionDetails" :value="filterDeliveryQualityInspectionDetail.deliveryInstructionDetailId" :reduce="item => item.id" v-model="filterDeliveryQualityInspectionDetail.deliveryInstructionDetailId" @search="getDeliveryInstructionDetails" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Part">
					<v-select id="input-delivery-quality-inspection-detail-part-table" append-to-body label="partNumber" :options="parts" :value="filterDeliveryQualityInspectionDetail.partId" :reduce="item => item.id" v-model="filterDeliveryQualityInspectionDetail.partId" @search="getParts" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty Deliver">
					<b-form-input id="input-delivery-quality-inspection-detail-qty-deliver-table" v-model="filterDeliveryQualityInspectionDetail.qtyDeliver" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( deliveryQualityInspectionDetailPageSize * (currentDeliveryQualityInspectionDetailPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(deliveryInstructionDetail)="row">
				<app-input-combobox-autocomplete :options="deliveryInstructionDetails" optionsLabel="part" optionsKey="id" :id="'input-delivery-quality-inspection-detail-delivery-instruction-detail-' + row.index" label-cols-lg="12" label="Delivery Instruction Detail" size="sm" :model.sync="row.item.deliveryInstructionDetailId"  @change="saveInputDeliveryQualityInspectionDetail(row.item)" :selected="row.item.deliveryInstructionDetail != null ? row.item.deliveryInstructionDetail.part : ''"  @input="getDeliveryInstructionDetails" :loading="isDeliveryInstructionDetailComboLoading"  :isUpdatable ="null"  :nolabel="true" />
			</template>
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-delivery-quality-inspection-detail-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputDeliveryQualityInspectionDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isUpdatable ="null"  :nolabel="true" />
			</template>
			<template v-slot:cell(qtyDeliver)="row">
				<app-input-textbox :id="'input-delivery-quality-inspection-detail-qty-deliver-' + row.index" label-cols-lg="12" label="Qty Deliver" size="sm" :model.sync="row.item.qtyDeliver"   @change="saveInputDeliveryQualityInspectionDetail(row.item)" :isUpdatable ="null"  :nolabel="true" />
			</template>

								
			<template v-slot:form-add-detail>
				<DeliveryQualityInspectionDetailInput 
					:model="modelDeliveryQualityInspectionDetail"
					:openPopup="isShowPopupDeliveryQualityInspectionDetail"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataDeliveryQualityInspectionDetail"/>
			</template>
			<template v-slot:upload-detail>
					<DeliveryQualityInspectionDetailUpload
					:openPopup="isShowPopupUploadDeliveryQualityInspectionDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataDeliveryQualityInspectionDetail"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentDeliveryQualityInspectionDetailPage"
				:total-rows="totalDeliveryQualityInspectionDetailRow"
				:per-page="deliveryQualityInspectionDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>
		<app-table-input 
			title = "Delivery Quality Inspection Card"
			:bordered="true" :items="deliveryQualityInspectionCards" 
			:fields="fieldsDeliveryQualityInspectionCard" 
			:busy="isDataLoading" 
			:sort-by.sync="sortByDeliveryQualityInspectionCard" 
			:sort-desc.sync="sortDescDeliveryQualityInspectionCard" small responsive	
			@editButtonMethod="editRowDataDeliveryQualityInspectionCard"	
			@deleteButtonMethod="deleteRowDataDeliveryQualityInspectionCard"	
			@showPopupAddMethod="addDataDeliveryQualityInspectionCard()"	
			@showPopupUploadMethod="showPopupUploadDeliveryQualityInspectionCard()"
			@downloadMethod="downloadDeliveryQualityInspectionCard()"
			@addFromClipboardMethod="addFromClipboardDeliveryQualityInspectionCard()"
			@replaceFromClipboardMethod="replaceFromClipboardDeliveryQualityInspectionCard()"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="true"	
			:showDownloadButton="true"	
			:isDownloadBusy="isDownloadDeliveryQualityInspectionCard"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowDeliveryQualityInspectionCardFilter = !isShowDeliveryQualityInspectionCardFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowDeliveryQualityInspectionCardFilter">
				<b-th></b-th>
				<b-th stacked-heading="Delivery Quality Inspection Detail">
					<v-select id="input-delivery-quality-inspection-card-delivery-quality-inspection-detail-table" append-to-body label="part" :options="deliveryQualityInspectionDetails" :value="filterDeliveryQualityInspectionCard.deliveryQualityInspectionDetailId" :reduce="item => item.id" v-model="filterDeliveryQualityInspectionCard.deliveryQualityInspectionDetailId" @search="getDeliveryQualityInspectionDetails" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Delivery Card">
					<v-select id="input-delivery-quality-inspection-card-delivery-card-table" append-to-body label="deliveryCardNumber" :options="deliveryInstructionDeliveryCards" :value="filterDeliveryQualityInspectionCard.deliveryCardId" :reduce="item => item.id" v-model="filterDeliveryQualityInspectionCard.deliveryCardId" @search="getDeliveryInstructionDeliveryCards" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="QC Status">
					<v-select id="input-delivery-quality-inspection-card-qc-status-table" append-to-body label="name" :options="qcStatuss" :value="filterDeliveryQualityInspectionCard.qcStatusId" :reduce="item => item.id" v-model="filterDeliveryQualityInspectionCard.qcStatusId" @search="getQcStatuss" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Remarks">
					<b-form-input id="input-delivery-quality-inspection-card-remarks-table" v-model="filterDeliveryQualityInspectionCard.remarks" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="QC Date">
					<app-input-datetimepicker-range id="fieldset-delivery-quality-inspection-card-qc-date-row" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="QC Date" size="sm" :modelFrom.sync="filterDeliveryQualityInspectionCard.qcDateFrom" :modelTo.sync="filterDeliveryQualityInspectionCard.qcDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button/>
				</b-th>
				<b-th stacked-heading="QC By">
					<v-select id="input-delivery-quality-inspection-card-qc-by-table" append-to-body label="firstName" :options="userInfos" :value="filterDeliveryQualityInspectionCard.qcById" :reduce="item => item.id" v-model="filterDeliveryQualityInspectionCard.qcById" @search="getUserInfos" :filterable ="true"></v-select>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( deliveryQualityInspectionCardPageSize * (currentDeliveryQualityInspectionCardPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(deliveryQualityInspectionDetail)="row">
				<app-input-combobox-autocomplete :options="deliveryQualityInspectionDetails" optionsLabel="part" optionsKey="id" :id="'input-delivery-quality-inspection-card-delivery-quality-inspection-detail-' + row.index" label-cols-lg="12" label="Delivery Quality Inspection Detail" size="sm" :model.sync="row.item.deliveryQualityInspectionDetailId"  @change="saveInputDeliveryQualityInspectionCard(row.item)" :selected="row.item.deliveryQualityInspectionDetail != null ? row.item.deliveryQualityInspectionDetail.part : ''"  @input="getDeliveryQualityInspectionDetails" :loading="isDeliveryQualityInspectionDetailComboLoading"  :isUpdatable ="null"  :nolabel="true" />
			</template>
			<template v-slot:cell(deliveryCard)="row">
				<app-input-combobox-autocomplete :options="deliveryInstructionDeliveryCards" optionsLabel="deliveryCardNumber" optionsKey="id" :id="'input-delivery-quality-inspection-card-delivery-card-' + row.index" label-cols-lg="12" label="Delivery Card" size="sm" :model.sync="row.item.deliveryCardId"  @change="saveInputDeliveryQualityInspectionCard(row.item)" :selected="row.item.deliveryCard != null ? row.item.deliveryCard.deliveryCardNumber : ''"  @input="getDeliveryInstructionDeliveryCards" :loading="isDeliveryInstructionDeliveryCardComboLoading"  :isUpdatable ="null"  :nolabel="true" />
			</template>
			<template v-slot:cell(qcStatus)="row">
				<app-input-combobox-autocomplete :options="qcStatuss" optionsLabel="name" optionsKey="id" :id="'input-delivery-quality-inspection-card-qc-status-' + row.index" label-cols-lg="12" label="QC Status" size="sm" :model.sync="row.item.qcStatusId"  @change="saveInputDeliveryQualityInspectionCard(row.item)" :selected="row.item.qcStatus != null ? row.item.qcStatus.name : ''"  @input="getQcStatuss" :loading="isQcStatusComboLoading"  :isUpdatable ="null"  :nolabel="true" />
			</template>
			<template v-slot:cell(remarks)="row">
				<app-input-textarea :id="'input-delivery-quality-inspection-card-remarks-' + row.index" label-cols-lg="12" label="Remarks" size="sm" :model.sync="row.item.remarks"  @change="saveInputDeliveryQualityInspectionCard(row.item)" :isUpdatable ="null"  :nolabel="true" />
			</template>
			<template v-slot:cell(qcDate)="row">
				<app-input-datetimepicker :id="'input-delivery-quality-inspection-card-qc-date-' + row.index" label-cols-lg="12" label="QC Date" size="sm" :model.sync="row.item.qcDate"   @change="saveInputDeliveryQualityInspectionCard(row.item)" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" :isUpdatable ="null"  :nolabel="true" />
			</template>
			<template v-slot:cell(qcBy)="row">
				<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" :id="'input-delivery-quality-inspection-card-qc-by-' + row.index" label-cols-lg="12" label="QC By" size="sm" :model.sync="row.item.qcById"  @change="saveInputDeliveryQualityInspectionCard(row.item)" :selected="row.item.qcBy != null ? row.item.qcBy.firstName : ''"  @input="getUserInfos" :loading="isUserInfoComboLoading"  :isUpdatable ="null"  :nolabel="true" />
			</template>

								
			<template v-slot:form-add-detail>
				<DeliveryQualityInspectionCardInput 
					:model="modelDeliveryQualityInspectionCard"
					:openPopup="isShowPopupDeliveryQualityInspectionCard"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataDeliveryQualityInspectionCard"/>
			</template>
			<template v-slot:upload-detail>
					<DeliveryQualityInspectionCardUpload
					:openPopup="isShowPopupUploadDeliveryQualityInspectionCard"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataDeliveryQualityInspectionCard"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentDeliveryQualityInspectionCardPage"
				:total-rows="totalDeliveryQualityInspectionCardRow"
				:per-page="deliveryQualityInspectionCardPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import DeliveryQualityInspection from '@/models/DeliveryQualityInspection/DeliveryQualityInspection';
import DeliveryQualityInspectionList from '@/models/DeliveryQualityInspection/DeliveryQualityInspectionList';
import DeliveryQualityInspectionFilter from '@/filters/DeliveryQualityInspection/DeliveryQualityInspectionFilter';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import DeliveryInstruction from '@/models/DeliveryInstruction/DeliveryInstruction';
import DeliveryInstructionFilter from '@/filters/DeliveryInstruction/DeliveryInstructionFilter';
import PickingStatus from '@/models/PickingStatus/PickingStatus';
import PickingStatusFilter from '@/filters/PickingStatus/PickingStatusFilter';
import DeliveryQualityInspectionDetail from '@/models/DeliveryQualityInspection/DeliveryQualityInspectionDetail';
import DeliveryQualityInspectionDetailFilter from '@/filters/DeliveryQualityInspection/DeliveryQualityInspectionDetailFilter';
import DeliveryQualityInspectionCard from '@/models/DeliveryQualityInspection/DeliveryQualityInspectionCard';
import DeliveryQualityInspectionCardFilter from '@/filters/DeliveryQualityInspection/DeliveryQualityInspectionCardFilter';
import DeliveryInstructionDetail from '@/models/DeliveryInstruction/DeliveryInstructionDetail';
import DeliveryInstructionDetailFilter from '@/filters/DeliveryInstruction/DeliveryInstructionDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import DeliveryQualityInspectionDetailInput from '@/views/DeliveryQualityInspection/DeliveryQualityInspectionDetailInput';
import DeliveryQualityInspectionDetailUpload from '@/views/DeliveryQualityInspection/DeliveryQualityInspectionDetailUpload';
import DeliveryInstructionDeliveryCard from '@/models/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCard';
import DeliveryInstructionDeliveryCardFilter from '@/filters/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCardFilter';
import QcStatus from '@/models/QcStatus/QcStatus';
import QcStatusFilter from '@/filters/QcStatus/QcStatusFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import DeliveryQualityInspectionCardInput from '@/views/DeliveryQualityInspection/DeliveryQualityInspectionCardInput';
import DeliveryQualityInspectionCardUpload from '@/views/DeliveryQualityInspection/DeliveryQualityInspectionCardUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		DeliveryQualityInspectionDetailInput,DeliveryQualityInspectionDetailUpload,
		AppInputTextarea,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		DeliveryQualityInspectionCardInput,DeliveryQualityInspectionCardUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsDeliveryQualityInspectionDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"deliveryInstructionDetail": { "class" : "th-delivery-instruction-detail first-child", "label" : "Delivery Instruction Detail", key: 'deliveryInstructionDetail', sortable: false}}, 
				{"part": { "class" : "th-part", "label" : "Part", key: 'part', sortable: false}}, 
				{"qtyDeliver": { "class" : "th-qty-deliver last-child", "label" : "Qty Deliver", key: 'qtyDeliver', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			fieldsDeliveryQualityInspectionCard: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"deliveryQualityInspectionDetail": { "class" : "th-delivery-quality-inspection-detail first-child", "label" : "Delivery Quality Inspection Detail", key: 'deliveryQualityInspectionDetail', sortable: false}}, 
				{"deliveryCard": { "class" : "th-delivery-card", "label" : "Delivery Card", key: 'deliveryCard', sortable: false}}, 
				{"qcStatus": { "class" : "th-qc-status last-child", "label" : "QC Status", key: 'qcStatus', sortable: false}}, 
				{"remarks": { "class" : "th-remarks d-stack-none", "label" : "Remarks", key: 'remarks', sortable: false}}, 
				{"qcDate": { "class" : "th-qc-date d-stack-none", "label" : "QC Date", key: 'qcDate', sortable: false}}, 
				{"qcBy": { "class" : "th-qc-by d-stack-none", "label" : "QC By", key: 'qcBy', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelDeliveryQualityInspectionDetail : {},
			isShowPopupDeliveryQualityInspectionDetail : false,
			isShowPopupUploadDeliveryQualityInspectionDetail : false,
			modelDeliveryQualityInspectionCard : {},
			isShowPopupDeliveryQualityInspectionCard : false,
			isShowPopupUploadDeliveryQualityInspectionCard : false,
			filterDeliveryQualityInspection : null,
			currentDeliveryQualityInspectionPage : 1,
			deliveryQualityInspectionPageSize: 10,
			sortByDeliveryQualityInspection: '',
			sortDescDeliveryQualityInspection: '',
			filterDeliveryQualityInspectionDetail : null,
			currentDeliveryQualityInspectionDetailPage : 1,
			deliveryQualityInspectionDetailPageSize: 10,
			sortByDeliveryQualityInspectionDetail: '',
			sortDescDeliveryQualityInspectionDetail: '',
			sortingByDeliveryQualityInspectionDetail: [],
			deliveryQualityInspectionDetails : [],
			deliveryQualityInspectionDetailId : '',
			totalDeliveryQualityInspectionDetailRow : 0,
			isShowDeliveryQualityInspectionDetailFilter: false,
			isDownloadDeliveryQualityInspectionDetail: false,
			filterDeliveryQualityInspectionCard : null,
			currentDeliveryQualityInspectionCardPage : 1,
			deliveryQualityInspectionCardPageSize: 10,
			sortByDeliveryQualityInspectionCard: '',
			sortDescDeliveryQualityInspectionCard: '',
			sortingByDeliveryQualityInspectionCard: [],
			deliveryQualityInspectionCards : [],
			deliveryQualityInspectionCardId : '',
			totalDeliveryQualityInspectionCardRow : 0,
			isShowDeliveryQualityInspectionCardFilter: false,
			isDownloadDeliveryQualityInspectionCard: false,
			deliveryInstructionDetails: [],
			parts: [],
			deliveryQualityInspectionDetails: [],
			deliveryInstructionDeliveryCards: [],
			qcStatuss: [],
			userInfos: [],
			deliveryInstructions: [],
			deliveryInstructions: [],
			isDeliveryInstructionComboLoading: false,
			pickingStatuss: [],
			deliveryQualityInspectionStatuss: [],
			isDeliveryQualityInspectionStatusComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isDeliveryInstructionComboLoading: false,
			isPickingStatusComboLoading: false,
			isDeliveryQualityInspectionComboLoading: false,
			isDeliveryInstructionDetailComboLoading: false,
			isPartComboLoading: false,
			isDeliveryQualityInspectionDetailComboLoading: false,
			isDeliveryInstructionDeliveryCardComboLoading: false,
			isQcStatusComboLoading: false,
			isUserInfoComboLoading: false,
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getDeliveryQualityInspection : async function(id) {
			this.isBusy = true;
			DeliveryQualityInspection.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadDeliveryQualityInspection = true;
			this.filterDeliveryQualityInspection.id = this.modelId;
			DeliveryQualityInspection.downloadDataDetail(this, this.filterDeliveryQualityInspection).then(result => {
				this.isDownloadDeliveryQualityInspection = false;
			}).catch(error => { this.isDownloadDeliveryQualityInspection = false; })
		},
		getDeliveryQualityInspectionDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterDeliveryQualityInspectionDetail);
			if (this.modelId == null) return;
			filter.deliveryQualityInspectionId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByDeliveryQualityInspectionDetail != null) {
				this.sortingByDeliveryQualityInspectionDetail[this.sortByDeliveryQualityInspectionDetail] = this.sortDescDeliveryQualityInspectionDetail;
			}
			let currentPage = (this.currentDeliveryQualityInspectionDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalDeliveryQualityInspectionDetailRow + 1;
				let page = Math.ceil(totalData/this.deliveryQualityInspectionDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.deliveryQualityInspectionDetailPageSize = 0;
			// disable paging end
			DeliveryQualityInspectionDetail.getList(this, filter, this.sortingByDeliveryQualityInspectionDetail, currentPage , this.deliveryQualityInspectionDetailPageSize).then(result => {
				this.currentDeliveryQualityInspectionDetailPage = currentPage + 1;
				this.deliveryQualityInspectionDetails = result.data;
				this.totalDeliveryQualityInspectionDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getDeliveryQualityInspectionCards : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterDeliveryQualityInspectionCard);
			if (this.modelId == null) return;
			filter.deliveryQualityInspectionId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByDeliveryQualityInspectionCard != null) {
				this.sortingByDeliveryQualityInspectionCard[this.sortByDeliveryQualityInspectionCard] = this.sortDescDeliveryQualityInspectionCard;
			}
			let currentPage = (this.currentDeliveryQualityInspectionCardPage - 1);
			if (isAddRow) {
				let totalData = this.totalDeliveryQualityInspectionCardRow + 1;
				let page = Math.ceil(totalData/this.deliveryQualityInspectionCardPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.deliveryQualityInspectionCardPageSize = 0;
			// disable paging end
			DeliveryQualityInspectionCard.getList(this, filter, this.sortingByDeliveryQualityInspectionCard, currentPage , this.deliveryQualityInspectionCardPageSize).then(result => {
				this.currentDeliveryQualityInspectionCardPage = currentPage + 1;
				this.deliveryQualityInspectionCards = result.data;
				this.totalDeliveryQualityInspectionCardRow = result.dataCount;
			}).catch(error => {});
		},
		getDeliveryQualityInspections : async function(input) {
			let filter = new DeliveryQualityInspectionFilter();
			if (input != undefined) {
				filter.DeliveryQualityInspectionNo = input;
			}
			this.isDeliveryQualityInspectionComboLoading = true;
			DeliveryQualityInspection.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryQualityInspections = result.data
				}
				this.isDeliveryQualityInspectionComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryQualityInspections : async function(input) {
			let filter = new DeliveryQualityInspectionFilter();
			if (input != undefined) {
				filter.deliveryQualityInspectionNo = input;
			}
			this.isDeliveryQualityInspectionComboLoading = true;
			DeliveryQualityInspection.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryQualityInspections = result.data
				}
				this.isDeliveryQualityInspectionComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryInstructionDetails : async function(input) {
			let filter = new DeliveryInstructionDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			this.isDeliveryInstructionDetailComboLoading = true;
			DeliveryInstructionDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionDetails = result.data
				}
				this.isDeliveryInstructionDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryQualityInspectionDetails : async function(input) {
			let filter = new DeliveryQualityInspectionDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			this.isDeliveryQualityInspectionDetailComboLoading = true;
			DeliveryQualityInspectionDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryQualityInspectionDetails = result.data
				}
				this.isDeliveryQualityInspectionDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryInstructionDeliveryCards : async function(input) {
			let filter = new DeliveryInstructionDeliveryCardFilter();
			if (input != undefined) {
				filter.deliveryCardNumber = input;
			}
			this.isDeliveryInstructionDeliveryCardComboLoading = true;
			DeliveryInstructionDeliveryCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionDeliveryCards = result.data
				}
				this.isDeliveryInstructionDeliveryCardComboLoading = false;
			})
			.catch(error => {});
		},
		getQcStatuss : async function(input) {
			let filter = new QcStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isQcStatusComboLoading = true;
			QcStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.qcStatuss = result.data
				}
				this.isQcStatusComboLoading = false;
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			this.isUserInfoComboLoading = true;
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
				this.isUserInfoComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryInstructions : async function(input) {
			let filter = new DeliveryInstructionFilter();
			if (input != undefined) {
				filter.diNumber = input;
			}
			DeliveryInstruction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructions = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDeliveryInstruction(item) {
			if(item == undefined || item == null) {
				this.model.deliveryInstructionId = null;
				this.model.deliveryInstruction = null;
			} else {
				this.model.deliveryInstructionId = item.id;
				this.model.deliveryInstruction = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getPickingStatuss : async function(input) {
			let filter = new PickingStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			PickingStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.pickingStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDeliveryQualityInspectionStatus(item) {
			if(item == undefined || item == null) {
				this.model.deliveryQualityInspectionStatusId = null;
				this.model.deliveryQualityInspectionStatus = null;
			} else {
				this.model.deliveryQualityInspectionStatusId = item.id;
				this.model.deliveryQualityInspectionStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.deliveryQualityInspectionInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					DeliveryQualityInspection.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'deliveryqualityinspectionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					DeliveryQualityInspection.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'deliveryqualityinspectionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					DeliveryQualityInspection.updateData(this, model, id)
					.catch((error) => {
						this.getDeliveryQualityInspection(id);
					});
				}
			});
		},
		onHidden() {
			this.getDeliveryQualityInspections();
		},
		addRowDataDeliveryQualityInspectionDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.deliveryQualityInspectionId =  this.modelId;
					DeliveryQualityInspectionDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getDeliveryQualityInspectionDetails(true);
						this.isShowPopupDeliveryQualityInspectionDetail = false;
					})
				} else {
					model.deliveryQualityInspectionId =  this.modelId;
					DeliveryQualityInspectionDetail.createDataDetail(this, model)
					.then(result => {
						this.getDeliveryQualityInspectionDetails(true);
						this.isShowPopupDeliveryQualityInspectionDetail = false;
					})
				}
			}
		},
		async editRowDataDeliveryQualityInspectionDetail(id) {
			this.deliveryQualityInspectionDetailId = id;
			this.isShowPopupDeliveryQualityInspectionDetail = true; 
		},
		async deleteRowDataDeliveryQualityInspectionDetail(id) {
			DeliveryQualityInspectionDetail.deleteData(this, id).then(result => { this.getDeliveryQualityInspectionDetails(); });
		},
		async resetDataDeliveryQualityInspectionDetail() {
			this.deliveryQualityInspectionDetailId = "";
			this.isShowPopupDeliveryQualityInspectionDetail = true;
		},
		async addDataDeliveryQualityInspectionDetail() {
			DeliveryQualityInspectionDetail.createData(this, { deliveryQualityInspectionId: this.modelId })
			.then(result => {
				this.getDeliveryQualityInspectionDetails(true);
			})
		},
		async addFromClipboardDeliveryQualityInspectionDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, deliveryQualityInspectionId: this.modelId });
				});
				DeliveryQualityInspectionDetail.addFromClipboard(this, parts).then(result => { this.getDeliveryQualityInspectionDetails() });
			});
		},
		async replaceFromClipboardDeliveryQualityInspectionDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, deliveryQualityInspectionId: this.modelId });
				});
				DeliveryQualityInspectionDetail.replaceFromClipboard(this, parts).then(result => { this.getDeliveryQualityInspectionDetails() });
			});   
		},
		showPopupUploadDeliveryQualityInspectionDetail() {
			if(this.deliveryQualityInspectionDetails != null && this.deliveryQualityInspectionDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap DeliveryQualityInspectionDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadDeliveryQualityInspectionDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadDeliveryQualityInspectionDetail = true;
			}
		},
		uploadDataDeliveryQualityInspectionDetail(modalEvent, newDatas) {
			this.isShowPopupUploadDeliveryQualityInspectionDetail = false; 
		},
		downloadDeliveryQualityInspectionDetail(modalEvent) {
			this.isDownloadDeliveryQualityInspectionDetail = true;
			this.filterDeliveryQualityInspectionDetail.deliveryQualityInspectionId = this.modelId;
			DeliveryQualityInspectionDetail.downloadDataDetail(this, this.filterDeliveryQualityInspectionDetail).then(result => {
				this.isDownloadDeliveryQualityInspectionDetail = false;
			}).catch(error => { this.isDownloadDeliveryQualityInspectionDetail = false; })
		},
		saveInputDeliveryQualityInspectionDetail(item) {
			if (this.deliveryQualityInspections != null && this.deliveryQualityInspections != undefined  && this.deliveryQualityInspections.length > 0) {
				item.deliveryQualityInspection = this.deliveryQualityInspections.find(q => q.id == item.deliveryQualityInspectionId);
			}
			if (this.deliveryInstructionDetails != null && this.deliveryInstructionDetails != undefined  && this.deliveryInstructionDetails.length > 0) {
				item.deliveryInstructionDetail = this.deliveryInstructionDetails.find(q => q.id == item.deliveryInstructionDetailId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					DeliveryQualityInspectionDetail.updateData(this, item, item.id);
				}
			});
		},
		addRowDataDeliveryQualityInspectionCard(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.deliveryQualityInspectionId =  this.modelId;
					DeliveryQualityInspectionCard.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getDeliveryQualityInspectionCards(true);
						this.isShowPopupDeliveryQualityInspectionCard = false;
					})
				} else {
					model.deliveryQualityInspectionId =  this.modelId;
					DeliveryQualityInspectionCard.createDataDetail(this, model)
					.then(result => {
						this.getDeliveryQualityInspectionCards(true);
						this.isShowPopupDeliveryQualityInspectionCard = false;
					})
				}
			}
		},
		async editRowDataDeliveryQualityInspectionCard(id) {
			this.deliveryQualityInspectionCardId = id;
			this.isShowPopupDeliveryQualityInspectionCard = true; 
		},
		async deleteRowDataDeliveryQualityInspectionCard(id) {
			DeliveryQualityInspectionCard.deleteData(this, id).then(result => { this.getDeliveryQualityInspectionCards(); });
		},
		async resetDataDeliveryQualityInspectionCard() {
			this.deliveryQualityInspectionCardId = "";
			this.isShowPopupDeliveryQualityInspectionCard = true;
		},
		async addDataDeliveryQualityInspectionCard() {
			DeliveryQualityInspectionCard.createData(this, { deliveryQualityInspectionId: this.modelId })
			.then(result => {
				this.getDeliveryQualityInspectionCards(true);
			})
		},
		async addFromClipboardDeliveryQualityInspectionCard() {
			let deliveryCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					deliveryCards.push({ deliveryCard: item, deliveryQualityInspectionId: this.modelId });
				});
				DeliveryQualityInspectionCard.addFromClipboard(this, deliveryCards).then(result => { this.getDeliveryQualityInspectionCards() });
			});
		},
		async replaceFromClipboardDeliveryQualityInspectionCard() {
			let deliveryCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					deliveryCards.push({ deliveryCard: item, deliveryQualityInspectionId: this.modelId });
				});
				DeliveryQualityInspectionCard.replaceFromClipboard(this, deliveryCards).then(result => { this.getDeliveryQualityInspectionCards() });
			});   
		},
		showPopupUploadDeliveryQualityInspectionCard() {
			if(this.deliveryQualityInspectionCards != null && this.deliveryQualityInspectionCards.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap DeliveryQualityInspectionCard akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadDeliveryQualityInspectionCard = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadDeliveryQualityInspectionCard = true;
			}
		},
		uploadDataDeliveryQualityInspectionCard(modalEvent, newDatas) {
			this.isShowPopupUploadDeliveryQualityInspectionCard = false; 
		},
		downloadDeliveryQualityInspectionCard(modalEvent) {
			this.isDownloadDeliveryQualityInspectionCard = true;
			this.filterDeliveryQualityInspectionCard.deliveryQualityInspectionId = this.modelId;
			DeliveryQualityInspectionCard.downloadDataDetail(this, this.filterDeliveryQualityInspectionCard).then(result => {
				this.isDownloadDeliveryQualityInspectionCard = false;
			}).catch(error => { this.isDownloadDeliveryQualityInspectionCard = false; })
		},
		saveInputDeliveryQualityInspectionCard(item) {
			if (this.deliveryQualityInspectionDetails != null && this.deliveryQualityInspectionDetails != undefined  && this.deliveryQualityInspectionDetails.length > 0) {
				item.deliveryQualityInspectionDetail = this.deliveryQualityInspectionDetails.find(q => q.id == item.deliveryQualityInspectionDetailId);
			}
			if (this.deliveryInstructionDeliveryCards != null && this.deliveryInstructionDeliveryCards != undefined  && this.deliveryInstructionDeliveryCards.length > 0) {
				item.deliveryCard = this.deliveryInstructionDeliveryCards.find(q => q.id == item.deliveryCardId);
			}
			if (this.qcStatuss != null && this.qcStatuss != undefined  && this.qcStatuss.length > 0) {
				item.qcStatus = this.qcStatuss.find(q => q.id == item.qcStatusId);
			}
			if (this.userInfos != null && this.userInfos != undefined  && this.userInfos.length > 0) {
				item.qcBy = this.userInfos.find(q => q.id == item.qcByUserName);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					DeliveryQualityInspectionCard.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadDeliveryQualityInspectionDetail = false; 
			this.isShowPopupDeliveryQualityInspectionDetail = false; 
			if (modalType == 'DeliveryQualityInspectionDetail') {
				this.getDeliveryQualityInspectionDetails();
			}
			this.isShowPopupUploadDeliveryQualityInspectionCard = false; 
			this.isShowPopupDeliveryQualityInspectionCard = false; 
			if (modalType == 'DeliveryQualityInspectionCard') {
				this.getDeliveryQualityInspectionCards();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowDeliveryQualityInspectionDetailFilter = true;
				//this.isShowDeliveryQualityInspectionCardFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterDeliveryQualityInspection = new DeliveryQualityInspectionFilter();
		this.filterDeliveryQualityInspectionDetail = new DeliveryQualityInspectionDetailFilter();
		this.filterDeliveryQualityInspectionCard = new DeliveryQualityInspectionCardFilter();
		//this.getDeliveryQualityInspections();
		//this.getDeliveryInstructionDetails();
		//this.getParts();
		//this.getDeliveryQualityInspectionDetails();
		//this.getDeliveryInstructionDeliveryCards();
		//this.getQcStatuss();
		//this.getUserInfos();
		//this.getDeliveryInstructions();
		//this.getPickingStatuss();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getDeliveryQualityInspection(id);
			} else {
				this.modelId = id;
				this.getDeliveryQualityInspection(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
		sortByDeliveryQualityInspectionDetail : {
			handler: function() {
				this.getDeliveryQualityInspectionDetails();
			}
		},
		sortDescDeliveryQualityInspectionDetail: {
			handler: function() {
				this.getDeliveryQualityInspectionDetails();
			}
		},
		currentDeliveryQualityInspectionDetailPage: {
			handler: function() {
				this.getDeliveryQualityInspectionDetails();
			}
		},
		deliveryQualityInspectionDetailPageSize : {
			handler: function() {
				this.getDeliveryQualityInspectionDetails();
			}
		},
		filterDeliveryQualityInspectionDetail: {
			handler: function() {
				this.getDeliveryQualityInspectionDetails();
			},
			deep: true,
		},
		sortByDeliveryQualityInspectionCard : {
			handler: function() {
				this.getDeliveryQualityInspectionCards();
			}
		},
		sortDescDeliveryQualityInspectionCard: {
			handler: function() {
				this.getDeliveryQualityInspectionCards();
			}
		},
		currentDeliveryQualityInspectionCardPage: {
			handler: function() {
				this.getDeliveryQualityInspectionCards();
			}
		},
		deliveryQualityInspectionCardPageSize : {
			handler: function() {
				this.getDeliveryQualityInspectionCards();
			}
		},
		filterDeliveryQualityInspectionCard: {
			handler: function() {
				this.getDeliveryQualityInspectionCards();
			},
			deep: true,
		},
	},
}
</script>
